export default {
  elements: [],
  element: null,
  type: null,
  toolbar: true,
  folder: {},
};
